import { API_HOST_NAME } from '../../constants.js'
import useAuthenticatedResources from '../../../../useAuthenticatedResources.js'

const useShellSessionsResources = (teamSlug) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamSlug}/shell/sessions`
  return useAuthenticatedResources(url)
}

const useNodeShellSessionsResources = (teamSlug, nodeId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamSlug}/nodes/${nodeId}/shell/sessions`
  return useAuthenticatedResources(url)
}

export { useShellSessionsResources, useNodeShellSessionsResources }
export default useShellSessionsResources
